import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useAppSelector } from "../../../redux/hooks";
import { formatCurrency } from "../../../utils/formatNumber";

interface ChartProps {
  data: { title?: string; current: number; previous: number; color: string }[];
  precision?: number;
  isCurrency?: boolean;
  showLegend?: boolean | undefined;
}

export function CurrentVsPreviousGroupedColumnChart({
  precision = 2,
  data,
  isCurrency,
  showLegend = false,
}: ChartProps) {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  const filteredData = data.filter(({ current, previous }) => current !== 0 || previous !== 0);

  const options: Highcharts.Options = {
    title: {
      text: "",
    },
    chart: {
      type: "column",
      style: {
        fontFamily: "Poppins",
        fontSize: "15px",
        cursor: "zoom-in",
      },
      height: "280px",
    },
    tooltip: {
      valueDecimals: precision,
    },
    xAxis: {
      categories: ["Previous", "Current"],
    },
    legend: { enabled: showLegend, verticalAlign: "top", margin: 0 },
    yAxis: [{ title: { text: "" } }],
    plotOptions: {
      column: {
        stacking: "normal",
        pointPadding: 0.05,
        groupPadding: 0.05,
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "13px",
          },
          formatter: function () {
            return isCurrency ?
                formatCurrency(this.y ?? 0, marketPlace, false, false, true)
              : Highcharts.numberFormat(this.y ?? 0, precision, ".", ",");
          },
        },
      },
    },
    series: filteredData.map(({ current, previous, title, color }) => {
      const maskedCurrent = current === 0 ? null : current;
      const maskedPrevious = previous === 0 ? null : previous;
      return {
        name: title,
        type: "column",
        data: [maskedPrevious, maskedCurrent],
        color: color,
      };
    }),
  };
  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
